import { render } from "./NewsDetails.vue?vue&type=template&id=24b64170&scoped=true"
import script from "./NewsDetails.vue?vue&type=script&lang=js"
export * from "./NewsDetails.vue?vue&type=script&lang=js"

import "./NewsDetails.vue?vue&type=style&index=0&id=24b64170&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b64170"]])

export default __exports__